
<div class="price-value" [class.bold]="hint">{{priceText}}</div>
@if (hint) {
<div class="mat-hint mat-caption price-type" [innerHtml]="sourceLabel"></div>
}

